'use client';

import { useMemo } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Button from '@alltrails/denali/components/Button';
import Image from '@alltrails/core/components/Image';
import type { ConditionStyleId } from '@alltrails/maps/types/Styles';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import styles from './TrailConditionsWeatherMapButton.module.scss';
import groundConditionsSrc from './images/groundConditions.avif';
import precipitationSrc from './images/precipitation.avif';
import snowDepthSrc from './images/snowDepth.avif';
import temperatureSrc from './images/temperature.avif';

type TrailConditionsWeatherMapButtonProps = {
  className?: string;
  condition: ConditionStyleId;
  onClick: () => void;
};

const TrailConditionsWeatherMapButton = ({ className, condition, onClick }: TrailConditionsWeatherMapButtonProps) => {
  const isMobile = useIsMobileSizedScreen();

  const src = useMemo(() => {
    switch (condition) {
      case 'groundConditions':
        return groundConditionsSrc;
      case 'precipitation':
        return precipitationSrc;
      case 'snowDepth':
        return snowDepthSrc;
      case 'temperature':
      default:
        return temperatureSrc;
    }
  }, [condition]);

  return (
    <Button
      className={classNames(styles.mapButton, className)}
      icon={<Image alt="" height={32} width={32} src={src} />}
      onClick={onClick}
      size={isMobile ? 'sm' : 'md'}
      testId="weather-map"
      text={<FormattedMessage defaultMessage="Weather map" />}
      variant="elevated"
    />
  );
};

export default TrailConditionsWeatherMapButton;
